export const VERIFICATION_POLL_INTERVAL_MS = 10000;
export const REDIRECT_DELAY_MS = 5000;
